// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"c125d5eb","465":"aab9be17","538":"9dde6400","626":"5036a912"}[chunkId] + ".chunk.js";
};